/* eslint max-params: ["error", 6] */
import { IPageAddCallback, api } from "./index";
import { PageType } from "../const";
import { lang } from "../context";
import { downloadModal } from "../contextModal/DownloadModal";

const download: IPageAddCallback = (
  props,
  isAllow,
  isTeam,
  globalContext,
  currentRouterInfo,
  type
) => {
  const { data, name } = props;

  if (data.page_type !== PageType.File) {
    return;
  }
  return [
    {
      children: lang("ctx.download.title"),
      callbackOrModal: async () => {
        downloadModal({
          newList: [{ ...data }],
          type,
          from: name
        });
      },
      isAllow,
      type: "download",
      icon: "pc_yundoc_download",
      splitCode: 1,
      allowTips: "文档已开启安全设置，您暂无权限下载"
      // tip: '文档已开启安全设置，您暂无权限下载',
    }
  ];
};

export default download;
